import { render, staticRenderFns } from "./ColumnSelector.vue?vue&type=template&id=63927088"
import script from "./ColumnSelector.vue?vue&type=script&lang=ts"
export * from "./ColumnSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports